module.exports = __webpack_public_path__ + "494cd07c/img/settings-icon.121d9519.svg";